export class VrEvent{
    vrEventId: number;
    linkedContentId: number;
    eventTypeId: number;
    eventTriggerId: number;
    // toBeRemoved: boolean;
}
